import { IBookingManagementActionTypes, IBookingManagementActionCreator } from "models/IBookingManagementState";

const initialState: any = {
  data: [],
};

const reducer = (state = initialState, { type, payload }: IBookingManagementActionCreator) => {
  switch (type) {
    case IBookingManagementActionTypes.FETCH_VEHICLS_SUMMARY_REQUEST:
      return {
        ...state,
        data: [],
      };
    case IBookingManagementActionTypes.FETCH_VEHICLS_SUMMARY_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
